// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import AboutPage from '../views/AboutPage.vue'
import ProductsPage from '../views/ProductsPage.vue'
import ProductDetailPage from '../views/ProductDetailPage.vue'
import BlogsPage from '../views/BlogsPage.vue'
import BlogDetailPage from '../views/BlogDetailPage.vue'
import CalculatorPage from '../views/CalculatorPage.vue'

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/about', name: 'About', component: AboutPage },
  { path: '/products', name: 'Products', component: ProductsPage },
  { path: '/products/:slug', name: 'ProductDetail', component: ProductDetailPage },
  { path: '/blog', name: 'Blog', component: BlogsPage },
  { path: '/blog/:slug', name: 'BlogDetail', component: BlogDetailPage },
  { path: '/calculator', redirect: '/calculator/vehicle' },
  { path: '/calculator/vehicle', name: 'CalculatorVehicle', component: CalculatorPage },
  { path: '/calculator/warehouse', name: 'CalculatorWarehouse', component: CalculatorPage },
  { path: '/calculator/custom', name: 'CalculatorCustom', component: CalculatorPage },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior() { return { top: 0 } }
})

export default router
